<iframe [src]="getSafeSrc()"></iframe>